import React from 'react';
import { ButtonStyled } from './index.style';

export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = 'primary',
      size = 'md',
      fullWidth = false,
      type = 'button',
      ...props
    },
    ref
  ) => {
    return (
      <ButtonStyled
        ref={ref}
        type={type}
        $variant={variant}
        $size={size}
        $fullWidth={fullWidth}
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';

export default Button;
